import { useState } from 'react';
// import ImgCrop from 'antd-img-crop';
import { Upload } from 'antd';

export const TableEditor = () => {
  const [tableData, setTableData] = useState([
    ['', '', ''],
    ['', '', ''],
    ['', '', ''],
  ]);
  const [rows, setRows] = useState(3);
  const [cols, setCols] = useState(3);

  const handleCellChange = (rowIdx, colIdx, value) => {
    const newData = [...tableData];
    newData[rowIdx][colIdx] = value;
    setTableData(newData);
  };

  const addRow = () => {
    setTableData([...tableData, Array(cols).fill('')]);
    setRows(rows + 1);
  };

  const addColumn = () => {
    setTableData(tableData.map((row) => [...row, '']));
    setCols(cols + 1);
  };

  const removeRow = () => {
    if (rows > 1) {
      setTableData(tableData.slice(0, -1));
      setRows(rows - 1);
    }
  };

  const removeColumn = () => {
    if (cols > 1) {
      setTableData(tableData.map((row) => row.slice(0, -1)));
      setCols(cols - 1);
    }
  };

  const [fileList, setFileList] = useState([
    {
      uid: '-1',
      name: 'image.png',
      status: 'done',
      url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    },
  ]);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    // <ImgCrop
    //   rotationSlider
    //   zoomSlider
    //   aspectSlider
    //   showGrid
    //   cropShape="rect"
    //   aspect={4 / 3}
    //   minZoom={0.5}
    //   maxZoom={3}
    //   quality={1}
    //   modalTitle="Crop Image"
    //   modalOk="Crop"
    //   modalCancel="Cancel"
    //   showReset
    //   resetText="Reset Crop"
    // >
    //   <Upload
    //     listType="picture-card"
    //     fileList={fileList}
    //     onChange={onChange}
    //     onPreview={onPreview}
    //   >
    //     {fileList.length < 5 && '+ Upload'}
    //   </Upload>
    // </ImgCrop>
    <></>
  );
};

export default TableEditor;
